import type { ReactNode } from "react";
import Logo from "@/components/Logo";

// Hawa Mahal backdrop (royalty-free Unsplash placeholder — swap for your own).
const BG_IMG =
  "https://images.unsplash.com/photo-1599661046289-e31897846e41?auto=format&fit=crop&w=2000&q=80";

/**
 * Glassmorphism auth shell.
 *   Layer 0 — full-bleed heritage image, pinned to all edges, object-cover.
 *   Overlay — dark navy gradient so text/card stay readable over any part of
 *             the photo (contrast guaranteed at the source, not left to luck).
 *   Layer 1 — a centered frosted-glass card that floats above the image via a
 *             large soft shadow + a thin light border (the "pane of glass" edge).
 * Fields and text inside are themed for the glass surface by the scoped
 * `.auth-card` rules in index.css, so Login/Signup need no changes.
 */
export default function AuthLayout({ children }: { children: ReactNode }) {
  return (
    <div className="relative min-h-screen w-full overflow-hidden">
      {/* Layer 0 */}
      <img
        src={BG_IMG}
        alt="Hawa Mahal, Jaipur"
        className="absolute inset-0 h-full w-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-br from-navy-900/85 via-navy-900/65 to-navy-900/85" />

      {/* Layer 1 */}
      <div className="relative z-10 grid min-h-screen place-items-center px-4 py-10">
        <div className="auth-card w-full max-w-md rounded-3xl border border-white/15 bg-white/10 p-8 shadow-[0_20px_60px_rgba(0,0,0,0.45)] backdrop-blur-2xl">
          <div className="mb-6 flex justify-center">
            <Logo variant="light" withTagline={false} />
          </div>
          {children}
        </div>
      </div>
    </div>
  );
}